import { _APIHandler } from "../utils/helper";

let baseUrl = "industries";
export const fetchIndustries = (queryParams) => _APIHandler.get(`${baseUrl}`, { params: queryParams });
export const fetchIndustryLists = () => _APIHandler.get(`${baseUrl}/lists`);
export const fetchIndustry = (id) => _APIHandler.get(`${baseUrl}/${id}`);
export const createIndustry = (data) => _APIHandler.post(`${baseUrl}`, data,);
export const updateIndustry = (id, data) => _APIHandler.put(`${baseUrl}/${id}`, data);
export const deleteIndustry = (id) => _APIHandler.delete(`${baseUrl}/${id}`);